<template>
  <v-container fluid color="white--text">
    <v-row>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title>Channel Codes</v-card-title>
          <v-card-subtitle>List of banks and their codes</v-card-subtitle>
          <v-card-text>
            This endpoint allows the merchant to populate the list of banks and their codes. Banks codes are used as channel codes to identify the bank to which you are sending money to.
          </v-card-text>
          <v-divider/>
          <v-divider/>
          <v-card-text>
            EndPoints:<br/>
            <div class="secondary pa-5" style="color: #e7e3fc">
              <strong>Sandbox</strong>
              <p class="ma-2">{{"https://sandbox.sasapay.app/api/v1/waas/channel-codes/"}}</p>
            </div>
          </v-card-text>
          <v-card-text>
            Request Parameters <br/>
            <v-icon color="primary">mdi-access-point-check</v-icon> <code>Authorization</code>  <br/>
          </v-card-text>
          <v-divider/>
          <v-card-text>
            Expected Results:<br/>

            Sasa<span class="red--text">Pay</span> returns the status code & a detailed message
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6" class="">
        <h3>Sample Request</h3>
        <code-editor
            :read_only="true"
            theme="dark"
            v-model="code"
            :wrap_code="false"
            :language_selector="true"
            class="github_dark"
            :copy_code="true"
            font_size="14px"
            height="50%"
            width="100%"
            :languages="[['python', 'Python'],['java','Java'],['php','Laravel'],['go','Go'],['csharp','C#'],['javascript', 'Node Js']]"
        ></code-editor>
        <v-divider/>
        <h3>Sample Response</h3>
        <code-editor
            :read_only="true"
            theme="dark"
            v-model="response"
            :wrap_code="false"
            :language_selector="true"
            class="github_dark"
            :copy_code="true"
            font_size="14px"
            width="100%"
            :languages="[['json','JSON']]"
        ></code-editor>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>

import {ipnRequest, IPNResponse} from "../../../../../shared/snippets/c2b/processPayment";

export default {
  name: "Authentications",
  // components: { VueStylelintEditor },
  data: () =>({
    selectedLanguage:"",
    code:"",
    response:"",
  }),
  mounted() {
    this.importAuthSnippets()//
    this.importResponse()
  },
  methods:{
    importAuthSnippets(){
      this.code=ipnRequest()
    },
    importResponse(){
      this.response=IPNResponse()
    },
  }
}
</script>

<style scoped>

</style>